import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import * as THREE from 'three';
import { PartListDialogComponent } from '../part-list-dialog/part-list-dialog.component';
import { PartListService } from '../part-list.service';
import { CADNodeEngine } from './cadnodeengine';

@Injectable({
    providedIn: 'root'
})
export class PartListManager {

    constructor(
        private dialog: MatDialog,
        private toastr: ToastrService,
        private partListService: PartListService
    ) { }

    /**
     * Creates a part list from the scene using the CAD engine
     * @param scene - The THREE.Scene containing the 3D objects
     * @param cad - The CADNodeEngine instance to get flattened nodes
     */
    public createPartList(scene: THREE.Scene, cad: CADNodeEngine): void {
        if (!scene) {
            this.toastr.warning('No scene available');
            return;
        }

        const flattenedNodes = cad.getFlattenedNodes(scene);
        if (!flattenedNodes || flattenedNodes.length === 0) {
            this.toastr.warning('No parts found in the scene');
            return;
        }

        // Extract unique userData field names from all nodes
        const userDataFields = new Set<string>();
        flattenedNodes.forEach(node => {
            if (node.userData) {
                Object.keys(node.userData).forEach(key => {
                    // Skip internal fields
                    if (!['faceCenters', 'row', 'commentrow', 'isHelper', 'path'].includes(key)) {
                        userDataFields.add(key);
                    }
                });
            }
        });

        // Open dialog with export options
        const dialogRef = this.dialog.open(PartListDialogComponent, {
            width: '500px',
            data: {
                userDataFields: Array.from(userDataFields)
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const { options, filename } = result;

                // Generate part list
                const rows = this.partListService.generatePartList(flattenedNodes, options);

                // Export based on selected option
                if (options.exportType === 'clipboard') {
                    this.partListService.exportToClipboard(rows)
                        .catch(err => console.error('Error exporting to clipboard:', err));
                } else if (options.exportType === 'excel') {
                    this.partListService.exportToExcel(rows, filename);
                }
            }
        });
    }
} 